import { DrawerContentScrollView, DrawerItemList } from '@react-navigation/drawer';
import { View, Text, StyleSheet } from 'react-native';
import Colors from '../resources/Colors';
import GlobalStyles from '../resources/Styles';
import { Divider, IconButton } from 'react-native-paper'; // Usando IconButton para la tachita

export const CustomDrawerContent = (props) => {
  const { navigation } = props; // Extraemos navigation para poder cerrar

  return (
    <DrawerContentScrollView {...props} style={{ backgroundColor: Colors.headerBlue }}>
      {/* 🟢 Contenedor del Header con la Tachita */}
      <View style={styles.headerWrapper}>
        <View style={styles.textContainer}>
          <Text style={styles.menuTitle}>MENU</Text>
          {/* <Text style={styles.menuSubtitle}>Panel de Agencia</Text> */}
        </View>
        
        {/* ❌ Botón de cerrar */}
        <IconButton
          icon="close"
          iconColor="white"
          size={24}
          onPress={() => navigation.closeDrawer()}
          style={styles.closeButton}
        />
      </View>

      <Divider style={styles.divider} />

      <View style={styles.itemListContainer}>
        <DrawerItemList {...props} />
      </View>
    </DrawerContentScrollView>
  );
};

const styles = StyleSheet.create({
    headerWrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between', // Separa el texto de la X
      alignItems: 'flex-start',
      paddingHorizontal: 15,
      paddingTop: 10,
      marginBottom: 5,
    },
    textContainer: {
      flex: 1, // Toma el espacio restante
    },
    menuTitle: {
      color: '#ffffff',
      fontSize: 20,
      fontWeight: 'bold',
    },
    menuSubtitle: {
      color: 'rgba(255, 255, 255, 0.5)',
      fontSize: 11,
      textTransform: 'uppercase',
    },
    closeButton: {
      margin: 0,
      marginTop: -5, // Ajuste fino para que quede alineada con el título
    },
    divider: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      marginHorizontal: 15,
      marginTop: 10,
    },
    itemListContainer: {
      marginTop: 10,
    },

    ...GlobalStyles,
});
